import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Heart } from "lucide-react";
import { RestaurantCard } from "@/components/customer/RestaurantCard";
import { EmptyState, VegDot } from "@/components/common";
import { api, inr } from "@/lib/api";

export default function Favorites() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const load = () => api.get("/favorites").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const unfav = async (id) => { await api.post("/favorites/toggle", { type: "restaurant", id }); load(); };

  return (
    <div className="min-h-screen bg-surface max-w-[520px] mx-auto pb-10">
      <div className="sticky top-0 z-40 bg-white border-b border-border px-3 py-3 flex items-center gap-2">
        <button onClick={() => nav(-1)} className="w-9 h-9 flex items-center justify-center tap"><ArrowLeft size={22} /></button>
        <h1 className="font-display font-bold text-lg">My Favorites</h1>
      </div>
      <div className="px-4 py-4">
        {!data ? <div className="skel h-40 rounded-2xl" /> :
          (data.restaurants.length === 0 && data.items.length === 0) ?
            <EmptyState icon={Heart} title="No favorites yet" subtitle="Tap the heart on any restaurant to save it here." cta="Explore" onCta={() => nav("/")} /> :
            <div className="grid gap-4">
              {data.restaurants.map((r) => <RestaurantCard key={r.id} r={r} wide onFav={unfav} faved />)}
              {data.items.map((i) => (
                <div key={i.id} onClick={() => nav(`/restaurant/${i.restaurant_id}`)} className="flex items-center gap-3 bg-white rounded-xl p-2.5 border border-border tap"><img src={i.image} alt="" className="w-14 h-14 rounded-lg object-cover" /><div className="flex-1"><div className="flex items-center gap-1.5"><VegDot veg={i.veg} /><span className="font-bold text-sm">{i.name}</span></div><div className="text-xs text-ink-600">{inr(i.price)}</div></div></div>
              ))}
            </div>}
      </div>
    </div>
  );
}
